import { createBrowserRouter, Navigate } from "react-router-dom";

import App from "App";
import LandingPage from "features/landing/pages/LandingPage";
import PlannerPage from "features/planner/pages/PlannerPage";
import PlannerProvider from "features/planner/state/PlannerProvider";
import ProgramsPage from "features/programs/pages/ProgramsPage";
import { ProgramsProvider } from "features/programs/state/ProgramsProvider";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    element: <App />,
    children: [
      {
        path: "/planner",
        element: <Navigate to="/planner/new" replace />,
      },
      {
        path: "/planner/:programId",
        element: (
          <PlannerProvider>
            <PlannerPage />
          </PlannerProvider>
        ),
      },
      {
        path: "/programs",
        element: (
          <ProgramsProvider>
            <ProgramsPage />
          </ProgramsProvider>
        ),
      },
      {
        path: "*",
        element: <Navigate to="/planner" replace />,
      },
    ],
  },
]);

export default router;
